module.exports = {"require":"กรุณา ระบุ"}


//////////////////
// WEBPACK FOOTER
// ./src/language/th/validate.json
// module id = 1016
// module chunks = 10